const card = () => import('@/views/main/card/card.vue')
export default {
  path: '/main/card',
  name: 'card',
  component: card,
  children: []
}
